<template>
  <iTabs
    v-model="activeTab"
    :tabs="tabs"
    :background-position="getOptionValue(BackgroundPosition)"
    :background-size="getOptionValue(BackgroundSize)"
    :background-repeat="getOptionValue(BackgroundRepeat)"

    :hover-background-position="getOptionValue(BackgroundPosition, BaseOption.$states.HOVER)"
    :hover-background-size="getOptionValue(BackgroundSize, BaseOption.$states.HOVER)"
    :hover-background-repeat="getOptionValue(BackgroundRepeat, BaseOption.$states.HOVER)"

    :style-overrides="{
      backgroundColor: getOptionValue(BackgroundColor),
      hoverBackgroundColor: getOptionValue(BackgroundColor, BaseOption.$states.HOVER),
    }"
  >
    <template #tab(stories)>
      <iText variant="subtle">
        Published stories preview
      </iText>
    </template>
    <template #tab(likes)>
      <iText variant="subtle">
        Loved stories preview
      </iText>
    </template>
    <template #tab(comments)>
      <iText variant="subtle">
        Commented stories preview
      </iText>
    </template>
    <template #tab(votes)>
      <iText variant="subtle">
        Voted stories preview
      </iText>
    </template>
    <template #tab(followers)>
      <iText variant="subtle">
        Followers preview
      </iText>
    </template>
    <template #tab(following)>
      <iText variant="subtle">
        Following preview
      </iText>
    </template>
    <template #tab(collections)>
      <iText variant="subtle">
        Collections preview
      </iText>
    </template>
  </iTabs>
</template>

<script>
// Outside-editor imports for the live tab content (StoriesUserLoved
// et al under `%/dynamic-component-editor/standard-elements/` are
// missing files, and the SmartFeed-based stores live outside the
// editor directory tree). Render plain placeholder text per tab so
// the element stays inside the editor boundary.
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";

import {
  UserProfilePageElementMixin,
} from "%/dynamic-component-editor/standard-pages/user-profile-page/user-profile-page-element-mixin";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import BackgroundRepeat from "%/dynamic-component-editor/options/background-repeat";
import BackgroundPosition from "%/dynamic-component-editor/options/background-position";
import BackgroundSize from "%/dynamic-component-editor/options/background-size";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";

export default {
  name: "UserProfileTabs",
  mixins: [UserProfilePageElementMixin],
  elementPanelSettings: {
    displayName: "User Profile Tabs",
    displayIcon: "menu",
    elementGroup: "userProfile",
    elementType: "element",
  },
  optionBundles: [
    BackgroundOptions,
  ],
  options: [
    new LayoutWidth({ default: "fill", hover: "fill" }, true),
  ],
  data() {
    return {
      activeTab: "stories",
      BackgroundColor,
      BackgroundRepeat,
      BackgroundPosition,
      BackgroundSize,
      BaseOption,
      tabs: [
        { value: "stories", label: "Stories" },
        { value: "likes", label: "Likes" },
        { value: "comments", label: "Comments" },
        { value: "votes", label: "Votes" },
        { value: "followers", label: "Followers" },
        { value: "following", label: "Following" },
        { value: "collections", label: "Collections" },
      ],
    };
  },
};
</script>
